import React from "react"
import { CreateNFeContext } from "../../../Context"
import CurrencyInput from "react-currency-input"

export default props => {
    const context = React.useContext(CreateNFeContext)

    return <div className={context.nfe.transport.mod_frete !== "9" ? "py-2" : "d-none"}>
        <p className="mb-0">
            Valor do Frete
        </p>
        <CurrencyInput
            data-cy-test="#nfe-issuer-transport-shipping-value"
            className="form-control"
            decimalSeparator=","
            thousandSeparator="."
            prefix="R$ "
            value={context.nfe.shipping_value}
            onChange={(str, value, e) => context.handlers.addShippingValue(value)}
        />
    </div>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/ShippingTransporter/ShippingValue/index.jsx